import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const WP_AJAX_URL = 'https://wasabara.com/wp-admin/admin-ajax.php';
const APP_DOMAIN  = 'apps.wasabara.com';

export default function AuthPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get('token');

    if (!token) {
      navigate('/login?error=no_token');
      return;
    }

    handleJwtLogin(token);
  }, []);

  async function handleJwtLogin(token: string) {
    try {
      // Step 1: Validate JWT with WordPress
      const res = await fetch(
        `${WP_AJAX_URL}?action=validate_app_token&token=${encodeURIComponent(token)}&audience=${APP_DOMAIN}`
      );
      const data = await res.json();

      if (!data.success) {
        console.error('JWT validation failed:', data.data);
        navigate('/login?error=invalid_token');
        return;
      }

      const { email, membership_level, username } = data.data;

      // Step 2: Call Supabase Edge Function to get/create user & session
      const { data: sessionData, error } = await supabase.functions.invoke('jwt-auth', {
        body: { email, membership_level, username }
      });

      if (error || !sessionData?.access_token) {
        console.error('Supabase session error:', error);
        navigate('/login?error=session_error');
        return;
      }

      // Step 3: Set the Supabase session
      await supabase.auth.setSession({
        access_token:  sessionData.access_token,
        refresh_token: sessionData.refresh_token,
      });

      navigate('/');

    } catch (err) {
      console.error('Auth error:', err);
      navigate('/login?error=unknown');
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '12px',
    }}>
      <img src="/wasabaraTR.png" alt="Wasabara" style={{ height: '64px' }} />
      <p style={{ color: '#64748b', fontSize: '16px' }}>Signing you in…</p>
    </div>
  );
}
